import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { finalize, takeUntil } from 'rxjs/operators';

import { CreateUsersCommand, CreateUsersDto } from 'src/app/core/api/models';
import { UsersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { FileService } from 'src/app/core/services/file.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';

@Component({
    selector: 'app-users-import-from-xlsx',
    templateUrl: './users-import-from-xlsx.component.html',
    standalone: false
})
export class UsersImportFromXlsxComponent
  extends BaseFormPageComponent
  implements OnInit
{
  translate = inject(TranslateService);

  @Input('type') userType: string;

  pageVocabs = 'pages.users.form.';
  file: File;
  //this field generated when file changed
  jsonData: Array<Object> = null;
  //list of column's in imported excel file
  importedColList: { value: string; key: string }[] = [];
  //total Item's in The Imported file
  totalEntry = 0;

  userName: string;
  nationalCode: string;
  identityNumber: string;
  firstName: string;
  lastName: string;
  fatherName: string;
  email: string;
  password?: string;
  isForeigner: string;
  zipCode: string;
  phone: string;
  mobile: string;
  faxNumber: string;
  address: string;
  zoneName: string;
  birthDate: string;
  expireDate: string;
  isActiveSend: string;
  descriptions: string;
  isActive: string;

  model: any = {};

  apiModel: CreateUsersCommand;
  isShowAlertDetailsInUploadMode: boolean = true;

  constructor(
    protected currentService: UsersService,
    protected fileService: FileService
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();

      this.getVocabs();
      this.initForm();
      this.fields = 'pages.users.importfromfile.fields.';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      organizationId: new FormControl(''),
      roleId: new FormControl(''),
      inputFile: new FormControl(''),
      userName: new FormControl('', Validators.required),
      nationalCode: new FormControl('', Validators.required),
      identityNumber: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      fatherName: new FormControl('', Validators.required),
      email: new FormControl(''),
      password: new FormControl(''),
      isForeigner: new FormControl(''),
      zipCode: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      mobile: new FormControl('', Validators.required),
      faxNumber: new FormControl(''),
      address: new FormControl('', Validators.required),
      zoneName: new FormControl('', Validators.required),
      birthDate: new FormControl('', Validators.required),
      expireDate: new FormControl(''),
      isActiveSend: new FormControl('', Validators.required),
      descriptions: new FormControl(''),
      isActive: new FormControl(''),
    });
  }

  async readFileAndCreateInMemoryData(file: File) {
    try {
      this.loading = true;

      if (file == null || file == undefined) {
        this.jsonData = null;
        this.loading = false;
        this.totalEntry = 0;
        this.importedColList = [];
        return;
      }

      this.fileService
        .readExcelFile(file)
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.loading = false))
        )
        .subscribe((data) => {
          this.importedColList = [];
          this.jsonData = null;
          this.totalEntry = 0;
          this.loading = false;
          // if (this.fileService.isValidColumnNames(data.columnNames)) {
          // this.importedColList = data.columnNames;
          this.importedColList = data.columnNames.map((str) => ({
            key: str,
            value: str,
          }));
          this.importedColList.unshift({
            key: '',
            value: this.translate.instant(this.fields + 'empty'),
          });

          this.jsonData = data.jsonData;
          this.totalEntry = this.jsonData.length;
          //}
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  async onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.unSubs();
      if (this.jsonData == null) {
        return;
      }
      this.loading = true;
      await this.makeApiInputViewModel();
      this.apiModel.organizationId = this.model?.organizationId;
      this.apiModel.roleIds = this.model?.roleIds;
      ConsoleService.info('users[0]', this.apiModel.users[0]);

      let firstRow = this.apiModel.users[0];
      if (String(firstRow.isActive) == '-')
        this.apiModel.users[0].isActive = false;

      if (String(firstRow.isForeigner) == '-')
        this.apiModel.users[0].isForeigner = false;

      if (firstRow.email == '-') this.apiModel.users[0].email = null;

      if (firstRow.password == '-') this.apiModel.users[0].password = null;

      this.currentService
        .usersCreateUsers({ body: this.apiModel })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseObserver);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onChangeAlertDetailsInUploadMode(event) {
    try {
      const timeOut = setTimeout(() => {
        this.isShowAlertDetailsInUploadMode = event.hasAttribute('open');
        clearTimeout(timeOut);
      }, 20);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  async makeApiInputViewModel() {
    try {
      this.apiModel = {
        users: [],
      };
      //now must create users one by one and add to the model
      for (let index = 0; index < this.jsonData.length; index++) {
        let user: CreateUsersDto = {};
        //#region map users
        if (this.mobile) {
          user.mobile = this.jsonData[index][this.mobile];

          // if (!user.mobile.toString().startsWith('98')) {
          //   user.mobile = '98' + user.mobile;
          // }
        }

        if (this.zipCode) user.zipCode = this.jsonData[index][this.zipCode];

        if (this.userName) user.userName = this.jsonData[index][this.userName];

        if (this.nationalCode)
          user.nationalCode = this.jsonData[index][this.nationalCode];

        if (this.identityNumber)
          user.identityNumber = this.jsonData[index][this.identityNumber];

        if (this.firstName)
          user.firstName = this.jsonData[index][this.firstName];

        if (this.lastName) user.lastName = this.jsonData[index][this.lastName];

        if (this.fatherName)
          user.fatherName = this.jsonData[index][this.fatherName];

        if (this.email) user.email = this.jsonData[index][this.email];

        if (this.password) user.password = this.jsonData[index][this.password];

        if (this.isForeigner)
          user.isForeigner = this.jsonData[index][this.isForeigner];

        if (this.phone) user.phone = this.jsonData[index][this.phone];

        if (this.faxNumber)
          user.faxNumber = this.jsonData[index][this.faxNumber];

        if (this.address) user.address = this.jsonData[index][this.address];

        if (this.zoneName) user.zoneName = this.jsonData[index][this.zoneName];

        if (this.birthDate)
          user.birthDate = this.jsonData[index][this.birthDate];

        if (this.expireDate)
          user.expireDate = this.jsonData[index][this.expireDate];

        if (this.isActiveSend)
          user.isActiveSend = this.jsonData[index][this.isActiveSend];

        if (this.descriptions)
          user.descriptions = this.jsonData[index][this.descriptions];

        if (this.isActive) user.isActive = this.jsonData[index][this.isActive];

        this.apiModel.users.push(user);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
